/* eslint-disable default-case */
import { bool, string } from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { metaDataElement, metaDataProperty } from '../../utils/cmPreviewMetaData';
import { selectPreferences } from '../../selectors/ContextSelector';
import analyticsActions from '../../actions/AnalyticsAction';
import RevieveModal from '../Revieve/RevieveModal';
import { commonAutomationIds } from '../CoreMediaPage/CMPage.config';

const ImageBanner = (props) => {
    const data = get(props, 'data', props);
    const href = get(data, 'urlHolder.value', '');
    const imgTarget = get(data, 'urlHolder.openInNewTab', true) ? '_blank' : '';
    const automationId = get(data, 'automationId', '');
    const preferences = useSelector((state) => selectPreferences(state));
    const plccAnalyticsTagName = get(preferences, 'plccAnalyticsTagName', 'PLCC');
    const dataPlccName = get(props, 'dataPlccName', '');
    const analyticsId = get(props, 'data.analyticsId', '');
    const dispatch = useDispatch();
    const { isCMPreview } = props;
    let lgAltText = '';
    let lgImageURL = '';
    let mdImageURL = '';
    let smImageURL = '';

    useEffect(() => {
        if (analyticsId.toUpperCase().includes(plccAnalyticsTagName) && !isEmpty(dataPlccName)) {
            const payloadParams = {
                plccBanner: dataPlccName,
            };
            const { plccViewsAnalytics } = analyticsActions;
            dispatch(plccViewsAnalytics(payloadParams));
        }
    }, []);
    /* istanbul ignore next */
    const applyPlccAnalytics = () => {
        const payloadParams = {
            plccBanner: dataPlccName,
        };

        const { plccApplyAnalytics } = analyticsActions;
        dispatch(plccApplyAnalytics(payloadParams));
    };

    const isPlccEnableLink = () => {
        return analyticsId.toUpperCase().includes(plccAnalyticsTagName) && !isEmpty(dataPlccName);
    };

    data?.pictureVariants.forEach((currentVariant) => {
        const { variant, target } = currentVariant;
        switch (variant) {
            case 'S':
                smImageURL = target?.fullyQualifiedUrl;
                break;
            case 'M':
                mdImageURL = target?.fullyQualifiedUrl;
                break;
            case 'XL':
                lgImageURL = target?.fullyQualifiedUrl;
                lgAltText = target?.alt;
                break;
        }
    });

    const componentRendered = () => {
        return (
            <picture
                data-automation-id={commonAutomationIds?.IMAGE}
                data-cm-metadata={isCMPreview && metaDataElement(data, 'pictures')}
            >
                {/* small/mobile breakpoint */}
                <source media="(max-width: 767px)" srcSet={smImageURL} />
                {/* medium/tablet breakpoint */}
                <source media="(max-width: 1279px)" srcSet={mdImageURL} />
                {/* large/desktop breakpoint */}
                <img
                    alt={lgAltText}
                    src={lgImageURL}
                    data-cm-metadata={isCMPreview && metaDataProperty('data')}
                    className={[dt(['w-full']), props.imageStyles].join(' ')}
                />
            </picture>
        );
    };

    const bannerImage = (
        <RevieveModal
            data={data.analyticsId}
            isCoremedia
            componentToBeRendered={componentRendered()}
        />
    );

    const linkImage = (
        <a
            href={href}
            target={imgTarget}
            data-cm-metadata={isCMPreview && metaDataProperty(data?.name)}
            data-automation-id={commonAutomationIds?.IMAGELINK}
        >
            {bannerImage}
        </a>
    );

    return (
        <div
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(isPlccEnableLink() && { onClick: applyPlccAnalytics })}
            data-cm-metadata={isCMPreview && metaDataElement(data)}
            data-automation-id={automationId}
            className={props.imageContainerStyle}
        >
            {href ? linkImage : bannerImage}
        </div>
    );
};

ImageBanner.defaultProps = {
    isCMPreview: false,
    imageContainerStyle: '',
    imageStyles: '',
};

ImageBanner.propTypes = {
    isCMPreview: bool,
    imageContainerStyle: string,
    imageStyles: string,
};

export default ImageBanner;
